import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import utils from "../../resources/utils";
import constant from "../../resources/constant";
import ImageLinks from "../../assets/Images/ImagesLink";
import Footer from "../../Footer";

const LanguageSelect = () => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const [selectedLanguage, setSelectedLanguage] = useState("");
  const [btnDisabled, setBtnDisabled] = useState(true);

  // Language options
  const languageOptions = [
    { code: "en", name: "English" },
    { code: "id", name: "Bahasa Indonesia" },
  ];

  useEffect(() => {
    // Load saved language preference
    const storedLanguage = utils._retrieveData(constant.SELECTED_LANGUAGE);
    if (storedLanguage) {
      let langCode = "";
      if (typeof storedLanguage === "string") {
        langCode = storedLanguage.split("-")[0];
      } else if (typeof storedLanguage === "object" && storedLanguage.code) {
        langCode = storedLanguage.code.split("-")[0];
      }
      // Normalize language code: treat 'in' as 'id'
      if (langCode === "in") {
        langCode = "id";
      }
      if (langCode) {
        setSelectedLanguage(langCode);
        setBtnDisabled(false);
      }
    }
  }, []);

  const handleLanguageSelect = (code) => {
    setSelectedLanguage(code);
    setBtnDisabled(false);
  };

  const on_confirm = () => {
    utils._storeData(constant.SELECTED_LANGUAGE, selectedLanguage);
    i18n.changeLanguage(selectedLanguage);
    navigate(-1);
  };

  return (
    <div className="min-h-[100vh] bg-white">
      {/* Header */}
      <div className="flex items-center gap-2 px-6 mt-10">
        <img src={ImageLinks.chevron_right} className="w-[18px] h-[19px]" alt="Back" onClick={() => navigate(-1)} />
        <p className="font-custom text-sm font-semibold text-dark_black">
          {t("language")}
        </p>
      </div>

      {/* Content */}
      <div className="mt-10">
        <p className="text-center text-2xl font-semibold text-[#7953D2]">
          {t("select_language")}
        </p>
        <p className="text-center text-sm text-xs font-medium text-dark_gray mt-2">
          {t("kindly_select_your_language_to_begin_your_journey")}
        </p>
      </div>

      {/* Language Options */}
      <div className="mt-4 px-4 flex flex-col gap-2 overflow-auto" style={{
        height: `calc(100vh - 280px - env(safe-area-inset-bottom))`,
        minHeight: `calc(100vh - 280px - env(safe-area-inset-bottom))`,
      }}>
        {languageOptions.map((lang, index) => {
          const isSelected = selectedLanguage === lang.code;
          return (
            <div
              key={index}
              className={`border-2 border-gray-300 rounded-lg py-3 px-4 cursor-pointer transition-colors duration-200 ${isSelected ? "border-secondary" : "border-accents"}`}
              onClick={() => handleLanguageSelect(lang.code)}
            >
              <div className="flex justify-between items-center">
                <div className="flex flex-col">
                  <p className="line-clamp-1 font-custom text-sm font-semibold text-dark_black">
                    {lang.name}
                  </p>
                  <p className="line-clamp-1 font-custom text-xs font-medium text-gray">
                    ({lang.code})
                  </p>
                </div>
                <img
                  src={
                    isSelected
                      ? ImageLinks.radio_fill
                      : ImageLinks.radio
                  }
                  alt="Radio"
                />
              </div>
            </div>
          );
        })}
      </div>

      {/* Confirm Button */}
      <div className="fixed bottom-[80px] left-0 right-0 px-6">
        <button
          onClick={on_confirm}
          disabled={btnDisabled}
          className={`font-custom w-full py-3 rounded-[30px] text-base font-semibold
            ${btnDisabled
              ? "bg-gray text-gray-200 cursor-not-allowed"
              : "bg-[#492897] text-white"}
            `}
        >
          {t("confirm")}
        </button>
      </div>

      <Footer bottom={0} bottom_safe_area={true} />
    </div>
  );
};

export default LanguageSelect;